import React, { useContext, useEffect } from "react";

import { requireUserLogin, requireUserVerify } from "../../routes/Auth";
import LeftMenu from "../../components/LeftMenu";

import MyRatings from "./MyRatings";
import { Context } from "../../GAContext";
import { CurrentPage, PageRoute } from "../../models";
import requireUsernameChange from "../../routes/Auth/HOCs/requireUsernameChange";

const MyRatingsPage = ({ location }) => {
  const [GaEvent, setGaEvent] = useContext(Context);

  useEffect(() => {
    setGaEvent(CurrentPage.myRatings);
    return () => {
      setGaEvent("");
    };
  }, []);

  return (
    <LeftMenu activeKey={PageRoute.myRatings} showGoogleAd={false}>
      <MyRatings location={location} />
    </LeftMenu>
  );
};

export default requireUserLogin(
  requireUsernameChange(
    requireUserVerify(
      MyRatingsPage
    )
  )
);


// WEBPACK FOOTER //
// ./src/containers/MyRatingsPage/index.tsx